import { render, staticRenderFns } from "./AddSkillStep2.vue?vue&type=template&id=6dd7ecce&scoped=true&"
import script from "./AddSkillStep2.vue?vue&type=script&lang=js&"
export * from "./AddSkillStep2.vue?vue&type=script&lang=js&"
import style0 from "./AddSkillStep2.vue?vue&type=style&index=0&id=6dd7ecce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd7ecce",
  null
  
)

export default component.exports